module.exports = __webpack_public_path__ + "img/jtr.9f0ced4d.png";